import * as React from 'react';
import { useEffect } from 'react';
import { batch, useSignal } from '@preact/signals-react';
import { useSignals } from '@preact/signals-react/runtime';
import { AnimatePresence } from 'motion/react';
import { ReferAFriendOverlay } from '@/features/common-overlays/refer-a-friend';
import Portal from '@/components/portal';

export function OverlayManager() {
  useSignals();
  const elementType = useSignal(OverlayType.NONE);
  const elementProps = useSignal<any>(null);

  const onClose = () => {
    showOverlay(OverlayType.NONE);
  };

  const handler = (ev: any) => {
    const overlayType: OverlayType = ev.detail?.type;
    const overlayProps: any = ev.detail?.props || {};
    overlayProps[`onClose`] = onClose;
    batch(() => {
      elementType.value = overlayType;
      elementProps.value = overlayProps;
    });
  };

  useEffect(() => {
    document.addEventListener(`vsly-show-overlay`, handler);
    return () => {
      document.removeEventListener(`vsly-show-overlay`, handler);
    };
  }, []);

  return (
    <Portal selector="body">
      <AnimatePresence>
        {elementType.value === OverlayType.REFER_A_FRIEND && (
          <ReferAFriendOverlay
            key={OverlayType.REFER_A_FRIEND}
            {...elementProps.value}
          />
        )}
        {elementType.value === OverlayType.NONE && null}
      </AnimatePresence>
    </Portal>
  );
}

export enum OverlayType {
  NONE = `none`,
  REFER_A_FRIEND = `refer-a-friend`,
}

export function showOverlay(type: OverlayType, props?: any) {
  const event = new CustomEvent(`vsly-show-overlay`, {
    detail: {
      type,
      props,
    },
  });
  document.dispatchEvent(event);
}

export interface ManagedOverlayProps {
  onClose?: () => void;
}
